export const VND_UNIT = 'VND'
export const ROW_FORMAT_VND_ID = ['STF', 'LTF']
export const ROW_FORMAT_TIME = [
  'RT0009',
  'RT0011',
  'RT0013',
  'RT0015',
  'RT0003',
  'RT0006',
]

export const DISPLAY_TYPES = {
  CORPORATE: 'CT',
  BANK: 'NH',
  SECURITIES: 'CK',
  LIFE_INSURANCE: 'BHNT',
  NON_LIFE_INSURANCE: 'BHPNT',
  NON_BANK: 'NonBank',
}

export const DISPLAY_OPTIONS = Object.keys(DISPLAY_TYPES).map((key) => ({
  isI18n: true,
  value: DISPLAY_TYPES[key],
  label: `portfolio.finance.${key}`,
}))

export const CHART_COLOR = {
  1: {
    stroke: '#006AA6',
    fill: 'rgba(113, 126, 205, 0.15)',
  },
  3: {
    stroke: '#F49966',
    fill: 'rgba(230, 150, 76, 0.15)',
  },
  2: {
    stroke: '#00A8B5',
    fill: 'rgba(0, 168, 181, 0.15)',
  },
}
